<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z" fill="#ced8e8"/>
    <path d="M8 4H14V6H8V4Z" fill="#ced8e8"/>
    <path d="M8 8.00024H14V10.0002H8V8.00024Z" fill="#ced8e8"/>
    <path d="M8 12.0001H14V14.0001H8V12.0001Z" fill="#ced8e8"/>
    <path d="M4 4H6V6H4V4Z" fill="#ced8e8"/>
    <path d="M4 8.00024H6V10.0002H4V8.00024Z" fill="#ced8e8"/>
    <path d="M4 12.0001H6V14.0001H4V12.0001Z" fill="#ced8e8"/>
  </svg>

</template>

<script>
    export default {
        name: 'icon-list'
    }
</script>